<template>
  <div
    class="bk-form-overlay"
    @click.stop
    @mousedown.stop
    @keyup.stop
    @keydown.stop
  >
    <div class="bk bk-form-overlay-background bk-overlay" />
    <Resizable :id="id" class="bk-form-overlay-resizable">
      <FormHeader
        :bundle="bundle"
        :icon="icon"
        :title="title"
        @close="onClose"
      />
      <div class="bk-form-overlay-content">
        <slot />
      </div>
      <div v-if="$slots.footer" class="bk bk-form-overlay-footer">
        <slot name="footer" />
      </div>
    </Resizable>
  </div>
</template>

<script setup>
import FormHeader from "./Header/index.vue";
import { Resizable } from "#blokkli/components";
defineProps({
  id: { type: String, required: true },
  bundle: { type: String, required: false },
  icon: { type: null, required: false },
  title: { type: String, required: true }
});
const emit = defineEmits(["close"]);
const onClose = () => {
  emit("close");
};
</script>

<script>
export default {
  name: "FormOverlay"
};
</script>
